import EvertecPaymentInfo from './EvertecPaymentInfo';

export default EvertecPaymentInfo;
